import React from 'react';
import PropTypes from 'prop-types';
import EntityPicker from './EntityPicker';

// Driver-focused wrapper around the shared EntityPicker. Options are PEOPLE
// (see driverOptions.js), one row each, keyed and selected by email — the
// stable identity. Display names are lossy, and a driverId repeats across the
// routes one person worked, which used to make duplicate rows both highlight
// with the second one un-selectable.
function triggerLabel(selected, showAllDrivers) {
  if (selected) {
    return selected.name;
  }
  return showAllDrivers ? 'All drivers' : 'Find driver';
}

function DriverPicker({
  drivers,
  selectedDriverEmail,
  showAllDrivers,
  onChange,
  align,
}) {
  const selected = drivers.find(
    (driver) => driver.email === selectedDriverEmail,
  );
  return (
    <EntityPicker
      items={drivers}
      selectedId={selectedDriverEmail}
      onChange={onChange}
      getItemId={(driver) => driver.email}
      getItemKey={(driver) => driver.email}
      getItemStatus={(driver) => driver.status}
      getItemName={(driver) => driver.name}
      getItemMini={(driver) =>
        driver.routeIds.length > 1 ? `${driver.routeIds.length} routes` : ''
      }
      getSearchText={(driver) => driver.name || ''}
      triggerLabel={triggerLabel(selected, showAllDrivers)}
      triggerSearchIcon
      allLabel="Show all drivers"
      allMini={String(drivers.length)}
      emptyText="No drivers match."
      searchPlaceholder="Search by name…"
      searchAriaLabel="Search drivers"
      align={align}
    />
  );
}

export const driverOptionShape = PropTypes.shape({
  email: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  routeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  status: PropTypes.string,
});

DriverPicker.propTypes = {
  drivers: PropTypes.arrayOf(driverOptionShape).isRequired,
  selectedDriverEmail: PropTypes.string,
  showAllDrivers: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  align: PropTypes.oneOf(['left', 'right']),
};

DriverPicker.defaultProps = {
  selectedDriverEmail: null,
  showAllDrivers: false,
  align: 'right',
};

export default DriverPicker;
